import React from 'react';
import { Shield, Award, Clock, CheckCircle, TrendingUp, Wrench } from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      icon: Shield,
      title: 'Garantie Retour Origine',
      description: 'Retour à la configuration d\'origine offert à tout moment',
      color: 'text-green-500'
    },
    {
      icon: Clock,
      title: 'Intervention Rapide',
      description: 'Reprogrammation en 2-3 heures seulement',
      color: 'text-blue-500'
    },
    {
      icon: CheckCircle,
      title: 'Contrôle Technique',
      description: '100% compatible avec le contrôle technique français',
      color: 'text-green-500'
    },
    {
      icon: TrendingUp,
      title: 'Gains Garantis',
      description: 'Performance et couple améliorés ou remboursé',
      color: 'text-red-500'
    },
    {
      icon: Wrench,
      title: '5 Ans d\'Expertise',
      description: 'Plus de 2000 véhicules reprogrammés avec succès',
      color: 'text-purple-500'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-950 to-slate-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Pourquoi choisir JC Performance-57 ?
          </h2>
          <p className="text-gray-400 text-lg">
            Votre tranquillité d'esprit est notre priorité
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <div
                key={index}
                className="group relative bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border-2 border-slate-700 hover:border-red-600 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                style={{
                  animation: `fadeIn 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className={`p-4 rounded-full bg-slate-900/50 ${badge.color} transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
                    <Icon className="h-8 w-8" strokeWidth={2} />
                  </div>
                  <h3 className="text-xl font-bold text-white group-hover:text-red-600 transition-colors">
                    {badge.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {badge.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-red-600 to-red-700 p-8 rounded-2xl shadow-2xl shadow-red-600/30">
            <p className="text-white text-2xl font-bold mb-4">
              🎯 Prêt à booster votre véhicule ?
            </p>
            <p className="text-red-100 mb-6">
              Contactez-nous pour un devis gratuit et sans engagement
            </p>
            <a
              href="tel:0749995728"
              className="inline-flex items-center bg-white text-red-600 hover:bg-gray-100 font-bold px-8 py-4 rounded-xl transition-all transform hover:scale-105 shadow-lg"
            >
              <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              07 49 99 57 28
            </a>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default TrustBadges;
